import styled, { css } from 'styled-components';
import { Empty } from 'components/atoms/empty';
import { ControlMessage } from './control-message';
import { UserMessage } from './user-message';

export const StyledEmpty = styled(Empty)`
  background-color: var(--white-100);
  justify-content: center;
`;

export const MessageListWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  * {
    overflow-anchor: none;
  }
`;

export const StartMarker = styled.div`
  flex: 1 1 auto;
`;

export const SeenBy = styled.div`
  position: absolute;
  right: 130px;
  top: 12px;
`;

export const MessageWrapper = styled.div`
  position: relative;
`;

export const EndMarker = styled.div`
  padding-bottom: var(--layout-01);
`;

const StyledControlMessage = styled(ControlMessage)``;
const StyledUserMessage = styled(UserMessage)``;

const LineInBetweenMessages = css`
  margin-top: 36px;

  &:before {
    background: var(--border-color);
    color: var(--border-color);
    content: '';
    height: 1px;
    left: 62px;
    position: absolute;
    top: -20px;
    width: 10px;
  }
`;

export const UserMessageWrapper = styled(StyledUserMessage)`
  + ${StyledControlMessage} {
    ${LineInBetweenMessages};
  }
`;

export const ControlMessageWrapper = styled(StyledControlMessage)`
  + ${StyledUserMessage} {
    ${LineInBetweenMessages};
  }
`;
